import styled from '@emotion/styled';
import { Alert } from 'antd';

export const FileContent = styled.pre`
  margin: 0;
  max-height: 60vh;
  overflow: auto;
  white-space: pre;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 12px;
  line-height: 1.5;
`;

export const FileModalStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 120px;
`;

export const FileNotice = styled(Alert)`
  margin-bottom: 16px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
`;

export const AccountName = styled.span`
  /* Shrink before the Archived marker instead of pushing it out of the cell. */
  min-width: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
